//COUPON OPTIONS
export const PRIMARY_TEXT_BUTTON = "/component/PRIMARY_TEXT_BUTTON";
export const SECONDARY_TEXT_BUTTON = "/component/SECONDARY_TEXT_BUTTON";
export const HAS_COUPON = "/component/HAS_COUPON";
export const COUPON_CARD_TITLE = "/component/COUPON_CARD_TITLE";
export const COUPON_CARD_AUX_TEXT = "/component/COUPON_CARD_AUX_TEXT";
export const COUPON_CARD_BG_COLOR = "/component/COUPON_CARD_BG_COLOR";
export const COUPON_CARD_PRIMARY_BUTTON_COLOR =
  "/component/COUPON_CARD_PRIMARY_BUTTON_COLOR";
export const COUPON_CARD_PRIMARY_BUTTON_TEXT_COLOR =
  "/component/COUPON_CARD_PRIMARY_BUTTON_TEXT_COLOR";
//LANDING OPTIONS
export const LANDING_ORDER = "/component/LANDING_ORDER";
export const LANDING_TITLE = "/component/LANDING_TITLE";
export const LANDING_NAME = "/component/LANDING_NAME";
export const IS_GENERIC = "/component/IS_GENERIC";
export const ESPECIFICS_COUPONS = "/component/ESPECIFICS_COUPONS";
//NAV OPTIONS
export const PARTNER_LOGO = "/component/PARTNER_LOGO";
export const VELOE_LOGO = "/component/VELOE_LOGO";
//BANNER HEADER OPTIONS
export const BANNER_PRIMARY_TEXT = "/component/BANNER_PRIMARY_TEXT";
export const HAS_PRIMMARY_BTN = "/component/HAS_PRIMMARY_BTN";
export const HAS_SECONDARY_BTN = "/component/HAS_SECONDARY_BTN";
export const SECONDARY_BORDER_BTN = "/component/SECONDARY_BORDER_BTN";
export const BANNER_SECONDARY_TEXT = "/component/BANNER_SECONDARY_TEXT";
export const BANNER_BG_IMAGE = "/component/BANNER_BG_IMAGE";
export const BANNER_TITULO = "/component/BANNER_TITULO";
export const BANNER_TITLE_COLOR = "/component/BANNER_TITLE_COLOR";
export const BANNER_MESSAGE = "/component/BANNER_MESSAGE";
export const BANNER_MESSAGE_COLOR = "/component/BANNER_MESSAGE_COLOR";
export const BANNER_BUTTON_PRIMARY_COLOR =
  "/component/BANNER_BUTTON_PRIMARY_COLOR";
export const BANNER_BUTTON_SECONDARY_COLOR =
  "/component/BANNER_BUTTON_SECONDARY_COLOR";
export const BANNER_BUTTON_PRIMARY_TEXT_COLOR =
  "/component/BANNER_BUTTON_PRIMARY_TEXT_COLOR";
export const BANNER_BUTTON_SECONDARY_TEXT_COLOR =
  "/component/BANNER_BUTTON_SECONDARY_TEXT_COLOR";
//DEFAULT PROMO OPTIONS
export const PARKING = "/component/PARKING";
export const TOLLS = "/component/TOLLS";
export const PARKING_AND_TOLL = "/component/PARKING_AND_TOLL";
export const REGULAMENTO = "/component/REGULAMENTO";
//SIMPLE SECTION OPTIONS
export const SIMPLE_SECTION_BACKGROUND_COLOR =
  "/component/SIMPLE_SECTION_BACKGROUND_COLOR";
export const SIMPLE_SECTION_DESCRIPTION =
  "/component/SIMPLE_SECTION_DESCRIPTION";
export const SIMPLE_SECTION_IMAGE = "/component/SIMPLE_SECTION_IMAGE";
export const SIMPLE_SECTION_TITLE = "/component/SIMPLE_SECTION_TITLE";
export const SIMPLE_SECTION_TEXT_COLOR = "/component/SIMPLE_SECTION_TEXT_COLOR";
//MAP OPTIONS
export const MAP_TITLE = "/component/MAP_TITLE";
export const MAP_DESCRIPTION = "/component/MAP_DESCRIPTION";
//STEPS OPTIONS
export const STEPS_BG_COLOR = "/component/STEPS_BG_COLOR";
export const STEPS = "/component/STEPS";
export const STEPS_TITLE = "/component/STEPS_TITLE";
export const STEPS_FIRST_ARROW = "/component/STEPS_FIRST_ARROW";
export const STEPS_SECOND_ARROW = "/component/STEPS_SECOND_ARROW";
//DOUBLE SECTION OPTION
export const DOUBLE_SECTION_BG_TOP_COLOR =
  "/component/DOUBLE_SECTION_BG_TOP_COLOR";
export const DOUBLE_SECTION_DESCRIPTION_TOP =
  "/component/DOUBLE_SECTION_DESCRIPTION_TOP";
export const DOUBLE_SECTION_IMAGE_TOP = "/component/DOUBLE_SECTION_IMAGE_TOP";
export const DOUBLE_SECTION_TITLE_TOP = "/component/DOUBLE_SECTION_TITLE_TOP";
export const DOUBLE_SECTION_TEXT_COLOR = "/component/DOUBLE_SECTION_TEXT_COLOR";
//TAG options
export const TAG_TITLE = "/component/TAG_TITLE";
export const TAG_TITLE_COLOR = "/component/TAG_TITLE_COLOR";
export const TAG_IMG = "/component/TAG_IMG";
export const TAG_TEXT_BUTTON = "/component/TAG_TEXT_BUTTON";
export const TAG_COLOR_BUTTON = "/component/TAG_COLOR_BUTTON";
export const TAG_COLOR_TEXT_BUTTON = "/component/TAG_COLOR_TEXT_BUTTON";
export const TAG_BG_COLOR = "/component/TAG_BG_COLOR";
